import React from 'react';
import { Separator } from "./CommonStyles";

const CustomSeparator = ({
    width,
    height
}) => {

    return (
        <Separator
            width={width}
            height={height}
        />
    );
    
};

export default CustomSeparator;